import { Fragment } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import colors from "@styling/colors";
import { fontSizes } from "@styling/fonts";
import { spacing } from "@styling/sizing";

const Root = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing.x05}px;
  font-size: ${fontSizes.small}px;
`;

const CrumbLink = styled(Link)`
  color: ${colors.primary};
  font-size: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const CrumbText = styled.span`
  color: ${colors.textMuted};
`;

const Separator = styled(ChevronRight)`
  color: ${colors.textMuted};
  flex-shrink: 0;
`;

export type PageBreadcrumbItem = {
  label: string;
  to?: string;
};

type PageBreadcrumbProps = {
  items: PageBreadcrumbItem[];
};

export const PageBreadcrumb = ({ items }: PageBreadcrumbProps) => {
  return (
    <Root aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <Fragment key={`${item.label}-${index}`}>
            {index > 0 && <Separator size={14} aria-hidden />}
            {isLast || !item.to ? (
              <CrumbText aria-current={isLast ? "page" : undefined}>{item.label}</CrumbText>
            ) : (
              <CrumbLink to={item.to}>{item.label}</CrumbLink>
            )}
          </Fragment>
        );
      })}
    </Root>
  );
};
